import "core-js/modules/es7.array.includes.js";
export var LOCALE_ISO = Object.freeze({
  'fr-FR': 'fr-FR',
  'nl-BE': 'nl-BE',
  'fr-BE': 'fr-BE',
  'de-DE': 'de-DE',
  'es-ES': 'es-ES',
  'it-IT': 'it-IT',
  'fr-LU': 'fr-LU',
  'nl-NL': 'nl-NL',
  'de-AT': 'de-AT',
  'pt-PT': 'pt-PT',
  'de-CH': 'de-CH',
  'it-CH': 'it-CH',
  'fr-CH': 'fr-CH',
  'en-GB': 'en-GB'
});
export var COUNTRIES = Object.freeze({
  FR: 'FR',
  BE: 'BE',
  ES: 'ES',
  DE: 'DE',
  IT: 'IT',
  LU: 'LU',
  NL: 'NL',
  AT: 'AT',
  PT: 'PT',
  CH: 'CH',
  UK: 'UK'
});
export var countryHasStore = local => {
  var countryWithStore = [LOCALE_ISO['fr-FR'], LOCALE_ISO['fr-BE'], LOCALE_ISO['nl-BE'], LOCALE_ISO['fr-CH'], LOCALE_ISO['de-CH'], LOCALE_ISO['it-CH'], LOCALE_ISO['de-DE'], LOCALE_ISO['fr-LU'], LOCALE_ISO['it-IT'], LOCALE_ISO['es-ES'], LOCALE_ISO['de-AT']];
  return countryWithStore.includes(local);
};
export var countryHasRelayDelivery = country => {
  var countryWithRelay = [COUNTRIES.FR, COUNTRIES.IT, COUNTRIES.ES, COUNTRIES.DE, COUNTRIES.NL, COUNTRIES.PT];
  return countryWithRelay.includes(country);
};
export var CNC_MARKET_OPEN = Object.freeze([COUNTRIES.FR, COUNTRIES.IT, COUNTRIES.ES, COUNTRIES.AT, COUNTRIES.DE, COUNTRIES.BE, COUNTRIES.LU]);
export var countriesClosed = Object.freeze(['UK']);